import { Injectable, isDevMode } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';

@Injectable()
export class AppConfigService {
  private appConfig;

  constructor(private http: HttpClient) { }


  loadAppConfig() {
    var url = "";
    if (environment.production)
      url = 'https://console.tuna.uy/configs/config.json';
    else
      if (environment.dev)
        url = 'https://console.dev.tuna.awc/configs/config.json';
      else
        url = 'https://console.tuna.lab/configs/config.json';

    return this.http
      .get(url)
      .toPromise()
      .then((data) => {
        this.appConfig = data;
      });
  }

  getConfig() {
    return this.appConfig;
  }
}
